import AudioPlayer from '@/Components/AudioPlayer';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Card } from '@mui/material';
import { memo } from 'react';
import useThemeStore from 'Theme/store';
import { getIcon, getImageProfile } from '../utils/galleryUtils';

function AudioCard({ audio, onClick, store }) {
  const model = audio.model;

  const { theme } = useThemeStore();

  const getGenderIcon = () => {
    switch (audio.metadata?.gender) {
      case 'male':
        return (
          <MaleIcon
            sx={{
              color: theme === 'dark' ? '#ADB1FF' : '#51526C',
              fontSize: 18,
            }}
          />
        );
      case 'female':
        return (
          <FemaleIcon
            sx={{
              color: theme === 'dark' ? '#ADB1FF' : '#51526C',
              fontSize: 18,
            }}
          />
        );
      default:
        return (
          <QuestionMarkIcon
            sx={{
              color: theme === 'dark' ? '#ADB1FF' : '#51526C',
              fontSize: 18,
            }}
          />
        );
    }
  };

  return (
    <Card
      className="scale-100 transition-all duration-300 hover:scale-105"
      sx={{
        boxShadow: 3,
        borderRadius: 3,
        p: 2,
        m: 0,
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        '&:hover': {
          transform: 'scale(1.05)',
        },
      }}
      onClick={(e) => {
        onClick(audio);
      }}
    >
      {/* Header */}
      <div className="flex font-figtree justify-between items-center mb-4">
        <div className="flex gap-[10px] items-center">
          <div className="w-8 h-8 flex items-center justify-center bg-platinum dark:bg-tornado-cloud rounded-[10px]">
            {getGenderIcon()}
          </div>
          <div className="font-bold text-lg leading-6 text-agate-violet dark:text-powder-blue">
            {audio.metadata?.voice_name || 'NN'}
          </div>
        </div>
        <div className="flex items-center gap-1">
          {store.profile._id !== audio.creator._id && getImageProfile(audio)}
          <div
            className={`flex items-center gap-1 font-figtree font-bold text-xs text-white uppercase px-[6px] py-[3px] bg-${
              model.color ? `[${model.color}]` : 'nue-blue'
            } rounded-lg`}
          >
            {getIcon(model)}
            <div className="line-clamp-1">{model.abbreviation}</div>
          </div>
        </div>
      </div>

      {/* Prompt */}
      <div className="font-figtree font-normal text-base leading-6 line-clamp-4 mb-4 select-none">
        {audio.generation_params?.prompt}
      </div>

      <AudioPlayer audioUrl={audio.url} />
    </Card>
  );
}

export default memo(AudioCard, (prevProps, nextProps) => {
  return prevProps.audio._id === nextProps.audio._id;
});
